<template>
  <g>
    <skylar :data="skylarData" />
    <dylan :data="dylanData" />
    <playerTwo :data="playerTwoData" />
    <playerOne :data="playerOneData" />
    <!-- fix mouth ulm -->
    <playerThree :data="playerThreeData" />
    <ulm :data="ulmData" />
  </g>
</template>

<script>
  import skylar from './background/skylarModThree'
  import dylan from './background/dylanModThree'
  import playerTwo from './background/player2ModThree'
  import playerOne from './background/player1ModThree'
  import playerThree from './background/player3ModThree'
  import ulm from './background/ulmModThree'

  import {
    characterSpeech
  } from '@/assets/js/utils/characterSpeech'

  const defaults = {
    blinking: false,
    speaking: false,
    headRotate: false,
    armRaised: true
  }

  export default {
    data() {
      return {
        skylarData: { ...defaults
        },
        dylanData: { ...defaults
        },
        playerTwoData: { ...defaults
        },
        playerOneData: { ...defaults
        },
        playerThreeData: { ...defaults
        },
        ulmData: { ...defaults
        }
      }
    },
    mounted() {

      // array of characters to iterate through
      const characters = [{
          data: this.skylarData
        },
        {
          data: this.dylanData
        },
        {
          data: this.playerTwoData
        },
        {
          data: this.playerOneData
        },
        {
          data: this.playerThreeData
        },
        {
          data: this.ulmData
        }
      ]

      // random number generator
      const generateRandom = (min, max) => {
        return Math.random() * (max - min) + min;
      }

      // blinking animation
      const createBlinkAnimation = (data) => {
        setInterval(() => {
          data.blinking = true
          setTimeout(() => {
            data.blinking = false
          }, 300)
        }, generateRandom(6000, 8000)) // make random number
      }

      // speaking animation
      const createSpeakingAnimation = (data, callback) => {
        callback = callback || function () {}
        setInterval(() => {
          characterSpeech(data, generateRandom(2, 5))
          if (generateRandom(-1, 1) > 0) { // fire callback (arm raise) half of the time
            callback()
          }
        }, generateRandom(6000, 8000)) // generateRandom(6000, 8000)
      }

      // head rotate animation
      const createHeadRotateAnimation = (data) => {
        setInterval(() => {
          data.headRotate = true
          setTimeout(() => {
            data.headRotate = false
          }, generateRandom(4000, 5600))
        }, generateRandom(10000, 12000))
      }

      // init animations
      for (let i = 0; i < characters.length; i++) {
        setTimeout(() => {
          createBlinkAnimation(characters[i].data)
          createSpeakingAnimation(characters[i].data, characters[i].callback)
          createHeadRotateAnimation(characters[i].data)
        }, generateRandom(0, 2000))
      }
    },
    components: {
      skylar,
      dylan,
      playerTwo,
      playerOne,
      playerThree,
      ulm
    }
  }

</script>



// WEBPACK FOOTER //
// backgroundCharactersTwo.vue?aff2f83a